var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPaperclip = function SvgPaperclip(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.99 24c-1.551 0-3.102-.59-4.282-1.77a6.06 6.06 0 0 1 0-8.563L14.993 1.383a4.734 4.734 0 0 1 6.687 0 4.734 4.734 0 0 1 0 6.687L11.244 18.505a3.406 3.406 0 0 1-4.812 0 3.406 3.406 0 0 1 0-4.811l7.983-7.983c.22-.22.576-.22.796 0l.265.265c.22.22.22.576 0 .796l-7.983 7.983a1.904 1.904 0 0 0 0 2.69 1.904 1.904 0 0 0 2.69 0L20.62 7.008a3.23 3.23 0 0 0 0-4.565 3.23 3.23 0 0 0-4.565 0L3.768 14.728a4.56 4.56 0 0 0 0 6.44 4.56 4.56 0 0 0 6.44 0l10.208-10.206c.22-.22.575-.22.795 0l.265.265c.22.22.22.576 0 .796L11.271 22.23A6.04 6.04 0 0 1 6.989 24"
  }))));
};
export default SvgPaperclip;